/**
 * This file contains dummy data.
 * uses hardcoded data for demonstration purposes.
 */

export const testCaseOptimizerData = [
  {
    serial_number: "1000",
    file_name: "Product_fullfilment",
    file_type: "CSV",
    file_size: "78MB",
    uploaded_date: "12/03/2024",
    action: {
      _config: {
        type: "icon",
        value: "delete",
        isClickable: true,
      },
    },
  },
  {
    serial_number: "1001",
    file_name: "Product_fullfilment",
    file_type: "CSV",
    file_size: "78MB",
    uploaded_date: "12/03/2024",
    action: {
      _config: {
        type: "icon",
        value: "delete",
        isClickable: true,
      },
    },
  },
  {
    serial_number: "1002",
    file_name: "Product_fullfilment",
    file_type: "CSV",
    file_size: "78MB",
    uploaded_date: "12/03/2024",
    action: {
      _config: {
        type: "icon",
        value: "delete",
        isClickable: true,
      },
    },
  },
  {
    serial_number: "1003",
    file_name: "Product_fullfilment",
    file_type: "CSV",
    file_size: "78MB",
    uploaded_date: "12/03/2024",
    action: {
      _config: {
        type: "icon",
        value: "delete",
        isClickable: true,
      },
    },
  },
];

export const sampleModelRecords = [
  {
    serial_number: "1000",
    name: "Model 1",
    author: "Renuka",
    publish_date_time: "04/06/2024-10.20.38",
    trained_date_time: "04/06/2024-10.20.38",
    data_size: "20MB",
    action: "",
  },
  {
    serial_number: "1001",
    name: "Model 2",
    author: "Renuka",
    publish_date_time: "04/06/2024-10.20.38",
    trained_date_time: "04/06/2024-10.20.38",
    data_size: "20MB",
    action: "",
  },
  {
    serial_number: "1002",
    name: "Model 3",
    author: "Renuka",
    publish_date_time: "04/06/2024-10.20.38",
    trained_date_time: "04/06/2024-10.20.38",
    data_size: "20MB",
    action: "",
  },
  {
    serial_number: "1003",
    name: "Model 4",
    author: "Renuka",
    publish_date_time: "04/06/2024-10.20.38",
    trained_date_time: "04/06/2024-10.20.38",
    data_size: "20MB",
    action: "",
  },
];

export const sampleMetaRecords = [
  {
    "row-select": "",
    serial_number: "1000",
    attribute: "Testcase name",
    character_width: 0,
    type: "blob",
    requiredModelBuild: "yes",
    action: "",
  },
  {
    "row-select": "",
    serial_number: "1000",
    attribute: "Testcase name",
    character_width: 0,
    type: "blob",
    requiredModelBuild: "no",
    action: "",
  },
  {
    "row-select": "",
    serial_number: "1000",
    attribute: "Testcase name",
    character_width: 0,
    type: "var_char",
    requiredModelBuild: "no",
    action: "",
  },
];

export const sampleThresholdRecords =
  // duplicate_accuracy_threshold: {
  //   cellStyles: {
  //     background: "#def3ff",
  //   },
  //   _config: {
  //     type: "group",
  //     fields: [
  //       {
  //         type: "select",
  //         label: "LB",
  //         key: "lbValue",
  //         value: 75,
  //         options: [
  //           {
  //             label: 75,
  //             value: 75,
  //           },
  //           {
  //             label: 95,
  //             value: 95,
  //           },
  //         ],
  //       },
  //       {
  //         type: "select",
  //         label: "UB",
  //         key: "ubValue",
  //         value: 95,
  //         options: [
  //           {
  //             label: 75,
  //             value: 75,
  //           },
  //           {
  //             label: 95,
  //             value: 95,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // overlapping_accuracy_threshold: {
  //   cellStyles: {
  //     background: "#e3e0ff",
  //   },
  //   _config: {
  //     type: "group",
  //     fields: [
  //       {
  //         type: "select",
  //         label: "LB",
  //         key: "lbValue",
  //         value: 55,
  //         options: [
  //           {
  //             label: 55,
  //             value: 55,
  //           },
  //           {
  //             label: 95,
  //             value: 95,
  //           },
  //         ],
  //       },
  //       {
  //         type: "select",
  //         label: "UB",
  //         key: "ubValue",
  //         value: 85,
  //         options: [
  //           {
  //             label: 45,
  //             value: 45,
  //           },
  //           {
  //             label: 85,
  //             value: 85,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  [
    {
      "row-select": "",
      feature_name: "Step description",
      order: 1,
      duplicate_accuracy_threshold: "",
      overlapping_accuracy_threshold: "",
    },
    {
      "row-select": "",
      feature_name: "Step description",
      order: 1,
      duplicate_accuracy_threshold: "",
      overlapping_accuracy_threshold: "",
    },
  ];

export const sampleComplexRecords = {
  columns: [
    {
      display_name: "S.No",
      key: "serial_number",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      display_name: "File Name",
      key: "file_name",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      display_name: "Type",
      key: "file_type",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      display_name: "Size",
      key: "file_size",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      display_name: "Uploaded Date",
      key: "uploaded_date",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
    {
      display_name: "Action",
      key: "action",
      headerStyles: {
        background: "#7593F2",
        padding: "4px 8px",
      },
    },
  ],
  rows: [
    {
      serial_number: "1000",
      file_name: "Product_fullfilment",
      file_type: "CSV",
      file_size: "78MB",
      uploaded_date: "12/03/2024",
      action: {
        _config: {
          type: "icon",
          value: "delete",
          isClickable: true,
        },
      },
    },
    {
      serial_number: "1001",
      file_name: "Product_service",
      file_type: "XLS",
      file_size: "2MB",
      uploaded_date: "13/03/2024",
      action: {
        _config: {
          type: "input",
          inputType: "text",
          value: "",
          placeholder: "Enter here..",
        },
      },
    },
    {
      serial_number: "1001",
      file_name: "Product_service",
      file_type: "XLS",
      file_size: "2MB",
      uploaded_date: "13/03/2024",
      action: {
        _config: {
          type: "textarea",
          value: "",
          placeholder: "Enter here..",
          classNames: "height-5rem",
        },
      },
    },
    {
      serial_number: "1002",
      file_name: "Product_deployment",
      file_type: "XLS",
      file_size: "12MB",
      uploaded_date: "13/03/2024",
      action: {
        _config: {
          type: "select",
          label: "Test label",
          value: "",
          placeholder: "",
          options: [
            {
              label: "abc",
              value: "abc",
            },
            {
              label: "abcd",
              value: "abcd",
            },
            {
              label: "abcde",
              value: "abcde",
            },
          ],
        },
      },
    },
    {
      serial_number: "1002",
      file_name: "Product_deployment",
      file_type: "XLS",
      file_size: "12MB",
      uploaded_date: "13/03/2024",
      action: {
        _config: {
          type: "group",
          fields: [
            {
              type: "select",
              value: "select 1",
              label: "LB",
              key: "ubValue",
              placeholder: "",
              options: [
                {
                  label: "123",
                  value: "abc",
                },
                {
                  label: "1234",
                  value: "abcd",
                },
                {
                  label: "12345",
                  value: "abcde",
                },
              ],
            },
            {
              type: "select",
              value: "",
              label: "UB",
              key: "lbValue",
              placeholder: "select 2",
              options: [
                {
                  label: "abc",
                  value: "abc",
                },
                {
                  label: "abcd",
                  value: "abcd",
                },
                {
                  label: "abcde",
                  value: "abcde",
                },
              ],
            },
          ],
        },
      },
    },
  ],
};

export const impactedTestCasesData = [
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
  {
    "row-select": "",
    open_modal: "",
    ai_report:
      "## Test Case Analysis: TC_404\n\n**Test Case ID:** 404\n\n**Status:** Failed (11 failed executions)\n\n**Description:** \n* **Test Name:** Verify whether there are no UI issues under",
    fail_ratio: 100,
    failed_count: 11,
    summarized_report: {
      core_description:
        "Multiple UI and backend issues preventing functionality in exathon portal",
      resolution:
        "Prioritize critical fixes, investigate APIs, review frontend code, validate data, and conduct thorough testing.",
    },
    test_case_id: 404,
    test_case_name:
      "Verify whether there are no UI issues under exathon portal",
  },
];

export const dummyModalFields = [
  {
    name: "User Story ID",
    mapping: "id",
  },
  {
    name: "User Story Description",
    mapping: "description",
  },
  {
    name: "Test Case ID",
    mapping: "tcId",
  },
  {
    name: "Acceptance Criteria",
    mapping: "acCriteria",
    type: "ol",
  },
  {
    name: "Test Case Title",
    mapping: "tcTitle",
  },
  {
    name: "Pre-condition",
    mapping: "preConditions",
  },
  {
    name: "Steps",
    mapping: "steps",
    type: "ol",
  },
  {
    name: "Expected Results",
    mapping: "expectedResults",
  },
  {
    name: "Source Code Path",
    mapping: "sourceCode",
  },
  {
    name: "Code Snippets",
    mapping: "code",
  },
];

export const dummyModalData = {
  id: "US0001",
  description:
    "As a user, i want to interact with a CartBean object to manage items in a shopping cart efficiently",
  testcaseId: "TC0002",
  acCriteria: [
    `Given a CartBean object is created, When setting a specific userId and getting the userId from the object, Then the userId should be successfully set and retrieved.`,
    `Given a CartBean object is created, When setting a specific userId and getting the userId from the object, Then the userId should be successfully set and retrieved.`,
    `Given a CartBean object is created, When setting a specific userId and getting the userId from the object, Then the userId should be successfully set and retrieved.`,
    `Given a CartBean object is created, When setting a specific userId and getting the userId from the object, Then the userId should be successfully set and retrieved.`,
    `Given a CartBean object is created, When setting a specific userId and getting the userId from the object, Then the userId should be successfully set and retrieved.`,
  ],
  tcTitle: "Test title",
  preCondition: "Some pre conditions here",
  steps: [
    "step 1 Lorem ipisum Lorem ipisum Lorem ipisum",
    "step 2 Lorem ipisum Lorem ipisum Lorem ipisum",
  ],
  expectedResults:
    "The userId is successfully set and retrieved from the CartBean object",
  path: "src/com/shash/beans/CartBean.java",
  code: "public int getQuantity(){ }",
};

export const testReformat = [
  {
    "row-select": "",
    serial_number: "1000",
    attribute: 254,
    character_width: "242",
    type: "CSV",
    requiredModelBuild: "533",
    action: "",
    name: "SCB_Test Cases",
    size: "20Mb",
  },
  {
    "row-select": "",
    serial_number: "1000",
    attribute: 82,
    character_width: "",
    type: "CSV",
    requiredModelBuild: "",
    action: "",
    name: "SCB_Test Cases",
    size: "20Mb",
  },
];

export const codeViewTableData = [
  {
    order: 14,
    value: "Type '5000.00' into element '//input[@id='fundTransferAmount']'",
    row_id: "14",
  },
  {
    order: 15,
    value: "Type '2025-01-07' into element '//input[@id='fundTransferDate']'",
    row_id: "15",
  },
  {
    order: 16,
    value: "Select  element '//select[@id='fundPurpose']'",
    row_id: "16",
  },
  {
    order: 17,
    value:
      "Type 'Dedicated account for funding educational expenses and academic-related costs' into element '//textarea[@id='senderDescription']'",
    row_id: "17",
  },
  {
    order: 18,
    value: "If (x=== 10)",
    type: "if",
    row_id: "18",
    children: [
      {
        order: 19,
        value: "messageService.sendMessage('Limit is 10')",
        row_id: "19",
      },
      {
        order: 20,
        value: "if (y === 10)",
        type: "if",
        row_id: "20",
        children: [
          {
            order: 21,
            value: `messageService.sendMessage('Both X and Y cannot be same')`,
            row_id: "21",
          },
        ],
      },
    ],
  },
  {
    order: 22,
    value: "Else",
    type: "else",
    row_id: "22",
    children: [
      {
        order: 23,
        value: `messageService.sendMessage('Both X and Y are not same')`,
        row_id: "23",
      },
    ],
  },
];

export const testRunLegendData = [
  {
    value: "check_circle",
    label: "In-Progress",
    iconStyles: {
      color: "#f3b033",
      "font-size": "16px",
    },
  },
  {
    value: "cancel",
    label: "Failed",
    iconStyles: {
      color: "#ff244c",
      "font-size": "16px",
    },
  },
  {
    value: "check_circle",
    label: "Passed",
    iconStyles: {
      color: "#6AD986",
      "font-size": "16px",
    },
  },

  {
    value: "cancel",
    label: "Aborted",

    iconStyles: {
      color: "#d4d4d4",
      "font-size": "16px",
    },
  },
];

export const testRunSummaryLegendData = [
  {
    value: "check_circle",
    label: "In-Progress",
    iconStyles: {
      color: "#f3b033",
      "font-size": "16px",
    },
  },
  {
    value: "cancel",
    label: "Fail",
    iconStyles: {
      color: "#ff244c",
      "font-size": "16px",
    },
  },
  {
    value: "check_circle",
    label: "Pass",
    iconStyles: {
      color: "#6AD986",
      "font-size": "16px",
    },
  },

  {
    value: "cancel",
    label: "Abort",

    iconStyles: {
      color: "#d4d4d4",
      "font-size": "16px",
    },
  },
];

export const mappingOverviewComponentData = [
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Project Manager, I want to create a new project, so that i can organize and manage tasks...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Team Member, i want to view all tasks assigned to me, so that i can prioritize my work ...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Product Owner, i want to set priorities for tasks, so that the team knows which tasks are most ...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Scrum Master, i want to be notified when a task is overdue, so that i can address any delays and ...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Team Member, i want to comment on tasks, so that i can communicate with my team and...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Project Manager, i want to assign tasks to specific team members, so that work is ...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
  {
    row_select: "",
    file_name: "BaseSetup.java",
    user_story:
      "As a Stakeholder, i want to view high-level project timelines and milestones, so that i can have a ...",
    test_case: "Verify exception handling",
    methods: "Verify exception handling",
    open_modal: "",
  },
];

export const testSourceCodeMappingData = [
  {
    userStoryId: "1",
    userStoryDescription: "eqeads",
    testcaseid: "testcase_1",
    testCaseTitle: "Testcase 1",
    sourcecodepath: "src/com/shashi/be",
    codeSnippets: "public String getUser()",
  },
];

export const expandTableData = [
  {
    row_id: 1,
    component: "BC_1",
    io: "Input",
    paramName: "-",
    paramType: "-",
    isExpandable: true,
    expand: false,
    expandedContent: {
      type: "structured",
      content: [
        {
          component: "",
          io: "Input",
          paramName: "Default",
          paramType: "Lorem ipsum dolor",
        },
      ],
    },
  },
  {
    row_id: 2,
    component: "BC_1",
    io: "Output",
    paramName: "-",
    paramType: "-",
    isExpandable: true,
    expand: false,
    expandedContent: {
      type: "structured",
      content: [
        {
          component: "",
          io: "Output",
          paramName: "Default",
          paramType: "Lorem ipsum dolor",
        },
        {
          component: "",
          io: "Input",
          paramName: "Lorem ipsum dolor",
          paramType: "Lorem ipsum dolor",
        },
      ],
    },
  },
  {
    row_id: 3,
    component: "BC_1",
    io: "-",
    paramName: "-",
    paramType: "Lorem ipsum dolor",
    isExpandable: false,
    expand: false,
    expandedContent: null,
  },
];

export const expandTableColumns = [
  {
    key: "row_expand",
    display_name: "",
    headerStyles: { background: "#7593F2", "font-weight": "600" },
  },
  {
    key: "component",
    display_name: "Reusable Component",
    cellStyles: {
      "font-weight": "500",
      "font-size": "13px",
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#FFFFFF",
    },
  },
  {
    key: "io",
    display_name: "Input/ Output",
    cellStyles: { width: "20%", "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#FFFFFF",
    },
    _config: {
      displayInColumn: false,
      type: "io",
    },
  },
  {
    key: "paramName",
    display_name: "Parameter Name",
    cellStyles: { width: "10%", "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#FFFFFF",
    },
  },
  {
    key: "paramType",
    display_name: "Parameter Type",
    cellStyles: { width: "40%", "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#FFFFFF",
    },
  },
  {
    key: "actions",
    display_name: "",
    cellStyles: { width: "30%", "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      color: "#FFFFFF",
    },
    _config: {
      displayInColumn: false,
      type: "button",
      name: "Open",
      classNames: "btn btn-info",
    },
  },
];

export const dummyDataD = [
  {
    page: "page1",
    url: "https://www.virtusa.com/brand/external/color",
  },
  {
    page: "page2",
    url: "https://www.virtusa.com/brand/external/color",
  },
  {
    page: "page3",
    url: "https://www.virtusa.com/brand/external/color",
  },
  {
    page: "page4",
    url: "https://www.virtusa.com/brand/external/color",
  },
];

export const dummyDataCol = [
  {
    key: "page",
    display_name: "Page Name",
    headerStyles: { background: "#7593F2", "font-weight": "600", width: "30%" },
  },

  {
    key: "url",
    display_name: "URL",
    cellStyles: { width: "60%", "font-size": "13px" },
    headerStyles: { background: "#7593F2", "font-weight": "600", width: "60%" },
  },
  {
    key: "actions",
    display_name: "",
    cellStyles: { width: "10%", "font-size": "13px" },
    headerStyles: { background: "#7593F2", "font-weight": "600", width: "10%" },
    _config: {
      displayInColumn: false,
      type: "icon",
      value: "more_horiz",
    },
  },
];

export const dummyScripts = {
  status: 200,
  message: "Success",
  data: {
    createdBy: {
      id: "216f38ae-7650-427f-b6a2-9bd217ee294a",
      email: "twathukara@virtusa.com",
      firstName: "Tharindu",
      lastName: "Wathukara",
      aboutYou: "ABCD",
      active: true,
      alreadyMember: false,
    },
    updatedBy: {
      id: "216f38ae-7650-427f-b6a2-9bd217ee294a",
      email: "twathukara@virtusa.com",
      firstName: "Tharindu",
      lastName: "Wathukara",
      aboutYou: "ABCD",
      active: true,
      alreadyMember: false,
    },
    createdAt: "2025-01-29T03:29:23.498836",
    updatedAt: "2025-02-02T12:14:37.07757",
    id: "282c1eca-0b49-4981-981f-3df7954833a8",
    scriptId: "ff67b2e8-e838-44d0-bbcf-731a201e9556",
    name: "Script1",
    increment: 12,
    version: "v1.0.0",
    type: "SCRIPT",
    variables: [
      {
        id: "cb6314ba-867e-4b4a-be1a-c14332993782",
        name: "User Details",
        dataType: "Map",
        value: {
          name: "Tharindu",
          role: "Dev",
        },
        active: true,
      },
      {
        id: "02192ace-d5ca-4c79-a5a7-a2a034903532",
        name: "User Details",
        dataType: "Map",
        value: {
          name: "Tharindu",
          role: "Dev",
        },
        active: true,
      },
      {
        id: "a3be3c15-a0da-4553-beab-0a1e0d3e2961",
        name: "User Details",
        dataType: "Map",
        value: {
          name: "Tharindu",
          role: "Dev",
        },
        active: true,
      },
    ],
    scriptParameters: [
      {
        id: "8108a8a8-f2a2-4b49-a365-5a4770a338a8",
        name: "User Details",
        dataType: "Map",
        type: "INPUT",
        value: {
          name: "",
          role: "",
        },
        active: true,
      },
      {
        id: "294bacd9-dd4c-4aa8-b512-af78a3b5cd90",
        name: "User Email",
        dataType: "String",
        type: "OUTPUT",
        value: "",
        active: true,
      },
      {
        id: "7f338b6a-c3f4-456e-9169-3e908d6a1b45",
        name: "User Details",
        dataType: "Map",
        type: "INPUT",
        value: {
          name: "",
          role: "",
        },
        active: true,
      },
      {
        id: "d9806068-b06e-44fd-9aca-ef03bfe488da",
        name: "User Email",
        dataType: "String",
        type: "OUTPUT",
        value: "",
        active: true,
      },
      {
        id: "cea640ae-edd7-49f7-8d0d-193391e5c88d",
        name: "User Details",
        dataType: "Map",
        type: "INPUT",
        value: {
          name: "",
          role: "",
        },
        active: true,
      },
      {
        id: "cf688c4c-fe7a-475c-935a-ac1c6f110a25",
        name: "User Email",
        dataType: "String",
        type: "OUTPUT",
        value: "",
        active: true,
      },
    ],
    steps: [
      {
        id: "47fa3aaa-133e-4812-8780-b17e9ec27278",
        name: "",
        sequence: 0,
        commandDefinitionId: "CMD_WEB_TYPE",
        stepParameters: [
          {
            id: "param_application",
            name: "Application",
            dataType: "Application",
            order: 0,
            value: "app-1",
            customInput: false,
            isOptional: false,
            isActive: true,
          },
          {
            id: "param_page",
            name: "Page",
            dataType: "Page",
            order: 1,
            value: "page_b",
            customInput: false,
            isOptional: false,
            isActive: true,
          },
          {
            id: "param_uiobject",
            name: "UIObject",
            dataType: "UiObject",
            order: 2,
            value: "object_d",
            customInput: false,
            isOptional: false,
            isActive: true,
          },
          {
            id: "param_text",
            name: "text",
            dataType: "String",
            order: 3,
            value: "google pixel",
            customInput: false,
            isOptional: false,
            isActive: true,
          },
          {
            id: "param_stop_on_failure",
            name: "stopOnFailure",
            dataType: "Boolean",
            order: 4,
            value: false,
            customInput: false,
            isOptional: false,
            isActive: true,
          },
          {
            id: "param_retry",
            name: "retry",
            dataType: "Integer",
            order: 5,
            value: 1,
            customInput: false,
            isOptional: true,
            isActive: true,
          },
        ],
      },
    ],
    lockedBy: {
      id: "216f38ae-7650-427f-b6a2-9bd217ee294a",
      email: "twathukara@virtusa.com",
      firstName: "Tharindu",
      lastName: "Wathukara",
      aboutYou: "ABCD",
      active: true,
      alreadyMember: false,
    },
    active: true,
    locked: true,
  },
  async: false,
};

export const agentData = [
  {
    check: "",
    name: "Agent_1",
    status: "online",
    type: "Local",
    size: "5",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Agent_1_crash",
    status: "crashed",
    type: "Local",
    size: "5",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
    crashLogs:
      " 112as234cvfgfgggggdh ygfdvrtvf555gcd xhygfvqcesdxu  hgw4566 3ddf  rter67ejcfghvcfghcfgvy444",
  },
  {
    check: "",
    name: "Agent_2",
    status: "offline",
    type: "Cluster",
    size: "2",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Agent_3",
    status: "online",
    size: "3",
    type: "Ec2",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Agent_4",
    status: "online",
    type: "Cluster",
    size: "2",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Agent_5",
    status: "lock",
    type: "Cluster",
    size: "2",
    apiKey:
      "112as234cvfgfgggggdhygfdvrtvf555gcdxhygfvqcesdxuhgw45663ddfrter67ejcfghvcfghcfgvy444",
    expiration: "March 05, 2025",
    edit: "",
  },
];

export const agentFields = [
  {
    key: "name",
    name: "Execution Engine Name",
    type: "text-input",
    placeholder: "Enter execution engine name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "type",
    name: "Type",
    type: "select-card",
    options: [
      {
        icon: "/assets/images/virtusa-icons/local-agent.svg",
        label: "Local",
        value: "LOCAL",
      },
      {
        icon: "/assets/images/virtusa-icons/cluster-agent.svg",
        label: "Cluster",
        value: "CLUSTER",
      }
    ],
    value: 'LOCAL',
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "expiration",
    name: "Expire Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const agentFieldsEdit = [
  {
    key: "name",
    name: "Execution Engine Name",
    type: "text-input",
    isDisabled: true,
    placeholder: "Execution Engine Name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "type",
    name: "Type",
    type: "select-card",
    options: [
      {
        icon: "/assets/images/virtusa-icons/local-agent.svg",
        label: "Local",
        value: "LOCAL",
      },
      {
        icon: "/assets/images/virtusa-icons/cluster-agent.svg",
        label: "Cluster",
        value: "CLUSTER",
      }
    ],
    value: 'LOCAL',
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "expiration",
    name: "Expire Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "col-md-6 mt-3",
  },
];

export const mostImpactedExpandField = [
  {
    name: "User Story Description",
    mapping: "userStoryDescription",
  },
  {
    name: "Acceptance Criteria",
    mapping: "acceptanceCriteria",
  },
  {
    name: "Test Case Id",
    mapping: "testcaseid",
  },
  {
    name: "Test Scenario",
    mapping: "testScenario",
  },
  {
    name: "Pre Condition",
    mapping: "pre_condition",
  },
  {
    name: "Steps",
    mapping: "steps",
  },
  {
    name: "Expected Results",
    mapping: "expectedResults",
  },
  {
    name: "Source Code Path",
    mapping: "sourcecodepath",
  },
  {
    name: "Code Snippet",
    mapping: "codesnippets",
    type: "code-snippet",
  },
  {
    name: "Method Name",
    mapping: "methodname",
  },
];

export const releaseDummyData = [
  {
    check: "",
    name: "Release_20_01_1",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien ornare vitae amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    startDate: "February 05, 2025",
    releaseDate: "February 10, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Release_15_02_1",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien ornare vitae amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    startDate: "February 10, 2025",
    releaseDate: "February 20, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Release_12_01_1",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien ornare vitae amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    startDate: "March 05, 2025",
    releaseDate: "March 05, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Release_21_02_1",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien ornare vitae amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    startDate: "March 15, 2025",
    releaseDate: "March 25, 2025",
    edit: "",
  },
  {
    check: "",
    name: "Release_22_01_1",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sapien ornare vitae amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    startDate: "March 05, 2025",
    releaseDate: "March 05, 2025",
    edit: "",
  },
];

export const releaseFields = [
  {
    key: "name",
    name: "Release Name",
    type: "text-input",
    placeholder: "Enter release name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "startDate",
    name: "Start Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
  {
    key: "releaseDate",
    name: "End Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
    linkedMinDateKey: "startDate",
  },
  {
    key: "description",
    name: "Release description",
    placeholder: "Enter release description",
    validations: {
      required: false,
    },
    customClass: "mt-3 height-5rem",
    type: "textarea",
  },
];
export const releaseFieldsEdit = [
  {
    key: "name",
    name: "Release Name",
    type: "text-input",
    placeholder: "Enter release name",
    required: true,
    isDisabled: true,
    customClass: "mt-3",
  },
   {
    key: "startDate",
    name: "Start Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
  {
    key: "releaseDate",
    name: "End Date",
    type: "date-picker",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
    linkedMinDateKey: "startDate",
  },
  {
    key: "description",
    name: "Release description",
    placeholder: "Enter release description",
    validations: {
      required: false,
    },
    customClass: "mt-3 height-5rem",
    type: "textarea",
  },
];

export const jiraConnFields = [
  {
    key: "connectionName",
    name: "Connection Name",
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "baseUrl",
    name: "Domain URL",
    type: "text-input",
    placeholder: "Domain URL",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "username",
    name: "Username",
    type: "text-input",
    placeholder: "Username",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "project",
    name: "Project Name",
    type: "text-input",
    placeholder: "Project Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "apiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
];

export const jiraConnFieldsEdit = [
  {
    key: "connectionName",
    name: "Connection Name",
    isDisabled: true,
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "baseUrl",
    name: "Domain URL",
    type: "text-input",
    placeholder: "Domain URL",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "username",
    name: "Username",
    type: "text-input",
    placeholder: "Username",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "project",
    name: "Project Name",
    type: "text-input",
    placeholder: "Project Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "apiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
];

export const llmConnFields = [
  {
    key: "llmConnName",
    name: "Connection Name",
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmBaseUrl",
    name: "Base URL",
    type: "text-input",
    placeholder: "Base URL",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmModelName",
    name: "Model Name",
    type: "text-input",
    placeholder: "Model Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmApiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
];

export const llmConnFieldsEdit = [
  {
    key: "llmConnName",
    name: "Connection Name",
    isDisabled: true,
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmBaseUrl",
    name: "Base URL",
    type: "text-input",
    placeholder: "Base URL",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmModelName",
    name: "Model Name",
    type: "text-input",
    placeholder: "Model Name",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
  {
    key: "llmApiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "col-md-12",
  },
];

export const llamaConnFields = [
  {
    key: "connectionName",
    name: "Connection Name",
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-12",
  },
  {
    key: "provider",
    name: "Provider",
    isDisabled: true,
    type: "text-input",
    placeholder: "Llama",
    validations: {
      required: true,
    },
    value : "Llama",
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
  {
    key: "apiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
];

export const llamaConnFieldsEdit = [
  {
    key: "connectionName",
    name: "Connection Name",
    isDisabled: true,
    type: "text-input",
    placeholder: "Connection Name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-12",
  }, 
  {
    key: "provider",
    name: "Provider",
    isDisabled: true,
    type: "text-input",
    placeholder: "Llama",
    validations: {
      required: true,
    },
    value : "Llama",
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
  {
    key: "apiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "API Key",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-6",
  },
];

export const devicesFields = [
  {
    id: "environment",
    name: "Environment",
    type: "select",
    placeholder: "Select environment",
    options: [
      { value: "LOCAL", label: "Local" },
      { value: "REMOTE", label: "Remote" },
    ],
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
  },
  {
    id: "agentIdL",
    name: "Execution Engine",
    type: "section-select",
    config: {
      iconType: "assetImage",
      placeholderText: "Select execution engine",
    },
    validations: {
      required: true,
    },
    fields: [],
    wrapperClass: "col-md-6",
    isOptional: true,
    visibleIf: { key: "environment", value: "LOCAL" },
  },
  {
    id: "agentId",
    name: "Execution Engine",
    type: "section-select",
    config: {
      iconType: "assetImage",
      placeholderText: "Select execution engine",
    },
    validations: {
      required: true,
    },
    fields: [],
    wrapperClass: "col-md-6",
    isOptional: true,
    visibleIf: { key: "environment", value: "REMOTE" },
  },
  {
    id: "name",
    name: "Device Name",
    type: "text-input",
    placeholder: "Enter device name",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
  },
  {
    id: "serialNumber",
    name: "Serial Number",
    type: "text-input",
    placeholder: "Enter serial number",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "LOCAL" },
  },
  {
    id: "platform",
    name: "Platform",
    type: "select",
    placeholder: "Select mobile platform",
    options: [
      { value: "ANDROID", label: "Android" },
      { value: "IOS", label: "iOS" },
    ],
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
  },
  {
    id: "platformVersion",
    name: "Platform Version",
    type: "text-input",
    placeholder: "Enter platform version",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
  },
  {
    id: "automationPort",
    name: "Automation Port",
    type: "text-input",
    placeholder: "0000",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "LOCAL" },
  },
  {
    id: "automationHost",
    name: "Host",
    type: "text-input",
    placeholder: "0.0.0.0",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "LOCAL" },
  },
  {
    id: "remoteEnvironment",
    name: "Remote Environment",
    type: "select",
    placeholder: "Select test environment",
    options: [
      { value: "BROWSER_STACK", label: "BrowserStack" },
      { value: "LAMBDA_TEST", label: "LambdaTest" },
    ],
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "REMOTE" },
  },
  {
    id: "username",
    name: "Username",
    type: "text-input",
    placeholder: "Enter username",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "REMOTE" },
  },
  {
    id: "accessKey",
    name: "Access Key",
    type: "password-input",
    placeholder: "Enter access key",
    validations: {
      required: true,
    },
    wrapperClass: "col-md-6",
    visibleIf: { key: "environment", value: "REMOTE" },
  },
  {
    type: "checkbox",
    id: "simulator",
    label: "This device is a simulator",
    wrapperClass: "col-md-12",
    isOptional: true,
  },
  {
    id: "config",
    name: "Remote Options",
    type: "table",
    placeholder: "Add options",
    keys: [
      "projectName",
      "buildName",
      "sessionName",
      "networkLogs",
      "debug",
      "local",
    ],
    columns: [
      {
        display_name: "Key",
        key: "key",
        headerStyles: {
          background: "#7593F2",
          width: "35%",
          color: "#fff",
        },
        _editConfig: {
          type: "input",
          placeholder: "Add key",
          isAutoCompleteEnable: true,
          autocompleteKey: "key",
        },
      },
      {
        display_name: "Value",
        key: "value",
        headerStyles: {
          background: "#7593F2",
          width: "40%",
          color: "#fff",
        },
        _editConfig: {
          type: "input",
          placeholder: "Add value",
        },
      },
      {
        key: "edit",
        display_name: "",
        cellStyles: { "font-size": "12px" },
        headerStyles: {
          background: "#7593F2",
          "font-weight": "600",
          width: "5%",
          color: "#fff",
        },
        _config: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/edit-light.svg",
          isClickable: "true",
          actionType: "edit",
        },
        _editConfig: {
          type: "svg-editor",
          actionType: "add",
          value: "../../../../assets/images/virtusa-icons/tick.svg",
          isClickable: "true",
        },
      },
      {
        key: "delete",
        display_name: "",
        cellStyles: { "font-size": "12px" },
        headerStyles: {
          background: "#7593F2",
          borderRadius: "0 6px 0 0",
          "font-weight": "600",
          width: "5%",
          color: "#fff",
        },
        _config: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/delete-light.svg",
          isClickable: "true",
          actionType: "delete",
        },
        _editConfig: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/cross.svg",
          isClickable: "true",
          actionType: "cancel",
        },
      },
    ],
    options: [],
    isOptional: true,
    wrapperClass: "col-md-12",
    visibleIf: { key: "remoteEnvironment", value: "BROWSER_STACK" },
  },
  {
    id: "configL",
    name: "Remote Options",
    type: "table",
    placeholder: "Add options",
    keys: [
      "build",
      "name",
      "isRealMobile",
      "network",
      "video",
      "console",
      "tunnel",
    ],
    columns: [
      {
        display_name: "Key",
        key: "key",
        headerStyles: {
          background: "#7593F2",
          width: "35%",
          color: "#fff",
        },
        _editConfig: {
          type: "input",
          placeholder: "Add key",
          isAutoCompleteEnable: true,
          autocompleteKey: "key",
        },
      },
      {
        display_name: "Value",
        key: "value",
        headerStyles: {
          background: "#7593F2",
          width: "40%",
          color: "#fff",
        },
        _editConfig: {
          type: "input",
          placeholder: "Add value",
        },
      },
      {
        key: "edit",
        display_name: "",
        cellStyles: { "font-size": "12px" },
        headerStyles: {
          background: "#7593F2",
          "font-weight": "600",
          width: "5%",
          color: "#fff",
        },
        _config: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/edit-light.svg",
          isClickable: "true",
          actionType: "edit",
        },
        _editConfig: {
          type: "svg-editor",
          actionType: "add",
          value: "../../../../assets/images/virtusa-icons/tick.svg",
          isClickable: "true",
        },
      },
      {
        key: "delete",
        display_name: "",
        cellStyles: { "font-size": "12px" },
        headerStyles: {
          background: "#7593F2",
          borderRadius: "0 6px 0 0",
          "font-weight": "600",
          width: "5%",
          color: "#fff",
        },
        _config: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/delete-light.svg",
          isClickable: "true",
          actionType: "delete",
        },
        _editConfig: {
          type: "svg-editor",
          value: "../../../../assets/images/virtusa-icons/cross.svg",
          isClickable: "true",
          actionType: "cancel",
        },
      },
    ],
    options: [],
    isOptional: true,
    wrapperClass: "col-md-12",
    visibleIf: { key: "remoteEnvironment", value: "LAMBDA_TEST" },
  },
];

export const addApplicationFields = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "text-input",
    placeholder: "Enter application name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "applicationType",
    name: "Application Type",
    type: "select",
    placeholder: "Application Type",
    validations: {
      required: true,
    },
    options: [
      {
        label: "Web",
        value: "Web",
      },
      {
        label: "Mobile - Native",
        value: "MOBILE-Native",
      },
      {
        label: "Mobile - Hybrid",
        value: "MOBILE-Hybrid",
        disabled: true,
      },
      {
        label: "Mobile - Mobile Web",
        value: "MOBILE-Mobile-Web",
        disabled: true,
      },
      {
        label: "Mobile - Cross Platform",
        value: "MOBILE-Cross-Platform",
        disabled: true,
      },
    ],
    customClass: "mt-3",
  }
];

export const addPageFields = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageName",
    name: "Page Name",
    type: "text-input",
    placeholder: "Enter page name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageURL",
    name: "Page URL",
    type: "text-input",
    placeholder: "Enter page URL",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const addUiObjectFields = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageName",
    name: "Page Name",
    type: "select",
    placeholder: "Select page name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "uiObjectName",
    name: "UI object name",
    type: "text-input",
    placeholder: "Enter UI object name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "locator",
    name: "Locator",
    type: "text-input",
    placeholder: "Enter locator",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "browser",
    name: "Browser",
    type: "select-card",
    validations: {
      required: true,
    },
    options: [
      {
        icon: "/assets/images/virtusa-icons/chrome.svg",
        label: "Google Chrome (Default)",
        value: "chrome",
      },
      {
        icon: "/assets/images/virtusa-icons/firefox.svg",
        label: "Mozilla Firefox",
        value: "firefox",
      },
      {
        icon: "/assets/images/virtusa-icons/edge.svg",
        label: "Microsoft Edge",
        value: "edge",
      },
    ],
    customClass: "mt-3",
  },
];

export const addLocatorFields = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageName",
    name: "Page Name",
    type: "select",
    placeholder: "Select page name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "uiObjectName",
    name: "UI object name",
    type: "select",
    options: [],
    placeholder: "Select UI object name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "locator",
    name: "Locator",
    type: "text-input",
    placeholder: "Enter locator",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "browser",
    name: "Browser",
    type: "select-card",
    validations: {
      required: true,
    },
    options: [
      {
        icon: "/assets/images/virtusa-icons/chrome.svg",
        label: "Google Chrome (Default)",
        value: "chrome",
      },
      {
        icon: "/assets/images/virtusa-icons/firefox.svg",
        label: "Mozilla Firefox",
        value: "firefox",
      },
      {
        icon: "/assets/images/virtusa-icons/edge.svg",
        label: "Microsoft Edge",
        value: "edge",
      },
    ],
    customClass: "mt-3",
  },
];

export const addUiObjectFieldsMobile = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageName",
    name: "Page Name",
    type: "select",
    placeholder: "Select page name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "uiObjectName",
    name: "UI object name",
    type: "text-input",
    placeholder: "Enter UI object name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "locator",
    name: "Locator",
    type: "text-input",
    placeholder: "Enter locator",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "platform",
    name: "Platform",
    type: "select-card",
    validations: {
      required: true,
    },
    options: [
      {
        icon: "/assets/images/virtusa-icons/android.svg",
        label: "Android",
        value: "android",
      },
      {
        icon: "/assets/images/virtusa-icons/ios.svg",
        label: "ios",
        value: "ios",
      }
    ],
    customClass: "mt-3",
  },
];

export const addLocatorFieldsMobile = [
  {
    key: "applicationName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "pageName",
    name: "Page Name",
    type: "select",
    placeholder: "Select page name",
    options:[],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "uiObjectName",
    name: "UI object name",
    type: "select",
    options: [],
    placeholder: "Select UI object name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "locator",
    name: "Locator",
    type: "text-input",
    placeholder: "Enter locator",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "platform",
    name: "Platform",
    type: "select-card",
    validations: {
      required: true,
    },
    options: [
      {
        icon: "/assets/images/virtusa-icons/android.svg",
        label: "Android",
        value: "android",
      },
      {
        icon: "/assets/images/virtusa-icons/ios.svg",
        label: "ios",
        value: "ios",
      }
    ],
    customClass: "mt-3",
  },
];

export const addTestSuiteFields = [
  {
    key: "suiteName",
    name: "Test suite name",
    type: "text-input",
    placeholder: "Enter test suite name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const addTestScriptFields = [
  {
    type: "toggle",
    key: "useCustomTestSuite",
    label: "Test suite is not required",
    wrapperClass: "col-md-12 mt-3",
    isOptional: true,
    value: true,
  },
  {
    key: "testSuite",
    name: "Test Suite",
    type: "select",
    placeholder: "Select test suite",
    options: [],
    validations: {
      required: false,
    },
    customClass: "mt-3",
    disabledIf: { key: "useCustomTestSuite", value: true },
  },
  {
    key: "scriptName",
    name: "Test script name",
    type: "text-input",
    placeholder: "Enter test script name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const addComponentFolderFields = [
  {
    key: "componentFolderName",
    name: "Component folder name",
    type: "text-input",
    placeholder: "Enter component folder name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const addComponentFields = [
  {
    key: "componentFolderName",
    name: "Component folder name",
    type: "select",
    placeholder: "Select component folder",
    options: [],
    validations: {
      required: false,
    },
    customClass: "mt-3",
  },
  {
    key: "componentName",
    name: "Component name",
    type: "text-input",
    placeholder: "Enter component name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
];

export const addParameterFields = [
  {
    key: "type",
    name: "Type",
    type: "label-card",
    options: [
      {
        label: "Input Parameter",
        value: "input",
      },
      {
        label: "Output Parameter",
        value: "output",
      },
    ],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "parameterName",
    name: "Parameter name",
    type: "text-input",
    placeholder: "Enter parameter name",
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "parameterType",
    name: "Parameter Type",
    type: "select",
    placeholder: "Select parameter type",
    options: [
      { value: "String", label: "String" },
      { value: "Integer", label: "Integer" },
      { value: "Double", label: "Double" },
      { value: "Boolean", label: "Boolean" },
    ],
    validations: {
      required: true,
    },
    customClass: "mt-3",
  },
  {
    key: "defaultValue",
    name: "Default Value",
    type: "text-input",
    placeholder: "Enter default value",
    validations: {
      required: false,
    },
    customClass: "mt-3",
  },
];

export const webScriptFields = [
  {
    key: "appName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options: [],
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass:"col-md-6"
  },
  {
    key: "url",
    name: "Base URL",
    type: "text-input",
    placeholder: "Enter base URL",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass:"col-md-6"
  },
]

export const mobileScriptFields = [
  {
    key: "appName",
    name: "Application Name",
    type: "select",
    placeholder: "Select application name",
    options: [],
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass:"col-md-6"
  },
  {
    key: "device",
    name: "Device",
    type: "select",
    placeholder: "Select device",
    options: [],
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass:"col-md-12"
  },
]

export const generateMappingFields = [
  {
    id: "llm",
    key: "llm",
    name: "LLM",
    type: "select",
    placeholder: "Select LLM",
    options: [],
    validations: {
      required: true,
    },
    wrapperClass: "col-md-12",
  },
   {
    id: "vectorDb",
    key: "vectorDb",
    name: "Vector Database",
    type: "select",
    placeholder: "Select Vector Database",
    options: [
      { value: "Pinecone", label: "pinecone" },
    ],
    validations: {
      required: true,
    },
    wrapperClass: "col-md-12",
  },
  {
    key: "apiKey",
    name: "API Key",
    type: "password-input",
    placeholder: "Add vector database API key",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-12",
  },
  {
    key: "githubRepoLink",
    name: "GitHub Repo Link",
    type: "text-input",
    placeholder: "Add GitHub repo link",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-12",
  },
  {
    key: "githubToken",
    name: "GitHub Token",
    type: "password-input",
    placeholder: "Add GitHub token",
    validations: {
      required: true,
    },
    customClass: "mt-3",
    wrapperClass: "col-md-12",
  },
]

export const userstoryDetails = [
  {
    name: "Description",
    mapping: "storydesc",
  },
  {
    name: "Acceptance Criteria",
    mapping: "acceptancecriteria",
  },
]